// Принимает массив названий, сортирует его по длине строк в порядке убывания и возвращает первую строку,
// длина которой не превышает 255 символов.
// Если такой строки нет, возвращается последняя строка, обрезанная до 255 символов.
export const getProperOrganizationName = (names: string[]) => {
  const sorted = names.slice().sort((a, b) => ((a || '').length - (b || '').length <= 0 ? 1 : -1));
  return sorted.find((item) => item.length <= 255) || (sorted.pop() || '').slice(0, 255);
};
